"use client";

import { LogoSava } from "@/app/auth/signin/component";
import React from "react";
import { isMobileOnly } from "react-device-detect";
import { Card, CardBody } from "@heroui/card";
import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import { motion } from "framer-motion";
import { PiDesktopTowerBold, PiDeviceMobileSlash, PiArrowLeft } from "react-icons/pi";

const IsMobileWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  
  if (isMobileOnly) {
    return (
      <div className="relative flex flex-col items-center justify-center h-screen w-screen overflow-hidden bg-background p-6">
        
        <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[500px] h-[500px] bg-danger/10 rounded-full blur-[120px] pointer-events-none" />

        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="w-full max-w-md z-10"
        >
          <Card className="border border-white/10 bg-content1/60 backdrop-blur-xl shadow-2xl">
            <CardBody className="flex flex-col items-center text-center gap-6 py-10 px-8">
              
              <div className="scale-110 mb-2">
                <LogoSava />
              </div>

              <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-tr from-default-100 to-default-50 shadow-inner">
                 <PiDesktopTowerBold className="text-primary text-4xl drop-shadow-sm" />
                 <div className="absolute -bottom-2 -right-2 bg-danger/10 text-danger border-2 border-background p-1.5 rounded-full">
                    <PiDeviceMobileSlash size={20} />
                 </div>
              </div>

              <div className="space-y-2">
                <h1 className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-foreground to-default-500">
                  Version Bureau Requise
                </h1>
                <p className="text-sm text-default-500 leading-relaxed">
                  L'interface d'administration <b>Sava Radio</b> est optimisée pour les écrans larges afin de garantir une gestion précise et sécurisée.
                </p>
                <p className="text-xs text-default-400 font-medium bg-default-100/50 py-2 px-3 rounded-lg border border-default-200/50">
                  Veuillez vous connecter depuis un ordinateur ou une tablette.
                </p>
              </div>

              <div className="flex flex-col gap-3 w-full mt-2">
                <Button 
                    as={Link} 
                    href="https://www.rtvsava.com" 
                    target="_blank"
                    variant="flat" 
                    color="default" 
                    startContent={<PiArrowLeft />}
                    className="font-medium"
                >
                    Retour à l'accueil public
                </Button>
              </div>

            </CardBody>
          </Card>

          <div className="mt-8 text-center">
             <p className="text-[10px] text-default-300 uppercase tracking-widest font-semibold">
                &copy; 2025 Sava Radio & TV
             </p>
          </div>
        </motion.div>
      </div>
    );
  }

  return <>{children}</>;
};

export default IsMobileWrapper;